import { formatInTimeZone } from "date-fns-tz";
import { type FC, useMemo } from "react";

import type { PageMetadata } from "@moment/api-collab/api-types";

export const PagePublishedOnDate: FC<{
	pageMetadata: PageMetadata | null;
}> = ({ pageMetadata }) => {
	const date = useMemo(() => {
		if (!pageMetadata?.publishedOn) {
			return;
		}

		return formatInTimeZone(pageMetadata.publishedOn, "UTC", "MMMM d, yyyy");
	}, [pageMetadata?.publishedOn]);

	if (!pageMetadata?.publishedOn) {
		return <></>;
	}

	return <div className="text-tertiary text-base font-medium">{date}</div>;
};
